// DateSquare.tsx

import React from "react";
import styled from "styled-components";
import { CalendarDayInfo } from "./Calendar";
import dayjs from "dayjs";
import { StyleSheetManager } from "styled-components";
import isPropValid from "@emotion/is-prop-valid";
const DateSquareWrapper = styled.div.attrs({ className: "date-sqaure" })<{ activeMonth: boolean; activeDay: boolean }>`
  display: flex;
  flex-direction: column;
  height: 6.1875rem;
  border-radius: 0.3125rem;
  border: ${(props) => (props.activeDay ? "2px solid #306CF6" : "1px solid #afafb1")};
  background: ${(props) => (props.activeDay ? "#D4E1FF" : props.activeMonth ? "#fff" : "#f5f5f4")};
  cursor: pointer;
  color: ${(props) => (props.activeDay ? "#36383d" : "#86888b")};
`;

const Day = styled.div.attrs({ className: "day-of-month" })<{ activeMonth: boolean }>`
  color: ${(props) => (props.activeMonth ? "#36383d" : "#86888b")};
  text-align: right;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 0.5rem 0.5rem 0 0;
`;
const EventContainer = styled.div.attrs({ className: "events-container" })`
  display: grid;
  grid-template-columns: auto 1fr;
  text-align: right;
  padding: 0 0.25rem 0.25rem 0.1rem;
  justify-content: center;
  align-items: center;
`;

export const ColoredEventCube = styled.div.attrs({ className: "event-cube" })<{ color: string }>`
  width: 1.125rem;
  height: 1.125rem;
  flex-shrink: 0;
  border-radius: 5px;
  margin-left: 5px;
  background-color: ${(props) => (props.color.includes("#") ? props.color : `#${props.color}`)};
`;

const EventTime = styled.div.attrs({ className: "event-time" })`
  font-size: 0.7rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-right: 0.25rem;
`;

const Elipse = styled.div.attrs({ className: "elipse" })`
  color: #86888b;
  text-align: center;
  font-size: 0.7rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const CalendarDay: React.FC<CalendarDayInfo> = ({ number, type, events, onClick, selectedMonth, month, selectedDay, year }) => {
  // Sort events by start time
  const sortedEvents = events.slice().sort((a, b) => a.start.diff(b.start));

  // Show only the first two events if there are 4 or more events
  const displayedEvents = sortedEvents.length >= 4 ? sortedEvents.slice(0, 2) : sortedEvents;

  // Show "..." as the third event if there are 4 or more events
  const showMore = sortedEvents.length >= 4;

  // Determine if the day is active based on selectedDay
  const isActiveDay = selectedDay ? dayjs(selectedDay).isSame(dayjs(`${year}-${month + 1}-${number}`), "day") : false;

  // Determine if the month is active based on selectedMonth
  const activeMonth = selectedMonth === month ? true : false;

  return (
    <StyleSheetManager shouldForwardProp={isPropValid}>
      <DateSquareWrapper onClick={onClick} activeMonth={activeMonth} activeDay={isActiveDay}>
        <Day activeMonth={activeMonth}>{number}</Day>
        {displayedEvents.map((event, index) => {
          const startTime = dayjs(event.start).format("h:mm A");
          return (
            <EventContainer key={index}>
              <ColoredEventCube color={event.color} />
              <EventTime>{startTime}</EventTime>
            </EventContainer>
          );
        })}
        {showMore && (
          <EventContainer>
            <Elipse></Elipse> <Elipse>+ {sortedEvents.length - 2} More</Elipse>
          </EventContainer>
        )}
      </DateSquareWrapper>
    </StyleSheetManager>
  );
};

export default CalendarDay;
